import { Compass } from "lucide-react";
import { Chapter, Reveal } from "./Chapter";
import { REGION } from "../lib/data";

export default function Region() {
  return (
    <section id="region" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 bg-pinedark text-sand grain overflow-hidden" data-testid="section-region">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <Chapter num="7" label="La région" dark />
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight">
                L'Aveyron <span className="italic font-medium text-gold">sauvage</span>,<br />
                à portée de tente.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sand/65 leading-relaxed">
              Entre Cahors et Rodez, à la frontière du Lot et à 15 min de Villefranche-de-Rouergue :
              bastides médiévales, gorges de l'Aveyron, vallées vertes et grands sites —
              le plus dur sera de choisir.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REGION.map((r, i) => (
            <Reveal key={r.title} delay={0.08 * i}>
              <article
                className="group relative h-72 overflow-hidden rounded-[1.75rem] shadow-xl shadow-black/20"
                data-testid={`region-card-${i}`}
              >
                <img
                  src={r.image}
                  alt={r.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-lakedeep/90 via-lakedeep/25 to-transparent" />
                <div className="absolute bottom-0 p-6 transition-transform duration-500 group-hover:-translate-y-1">
                  <h3 className="font-display font-bold text-xl text-sand">{r.title}</h3>
                  <p className="mt-1.5 text-sm text-sand/70 leading-relaxed">{r.text}</p>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.4}>
            <div className="h-72 rounded-[1.75rem] border-2 border-dashed border-sand/25 grid place-items-center text-center p-8">
              <div>
                <span className="mx-auto grid place-items-center w-14 h-14 rounded-full bg-gold text-pinedark">
                  <Compass size={24} />
                </span>
                <p className="mt-5 font-display italic text-2xl text-sand/90">et tant d'autres…</p>
                <p className="mt-2 font-hand text-2xl text-gold -rotate-2">à découvrir depuis le camping</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
